
import { filtersDTO, NotUPResponseDTO, NotUpUpdateDTO } from "./dto";
import { NotProductiveUnitImpl } from "./serviceImpl";

export interface NotProductiveUnitService {
    GetAllProductiveUnit(filters: filtersDTO): Promise<NotUPResponseDTO>
    UpdateUp(data: NotUpUpdateDTO, id: string): Promise<void>
}

export function NewProductiveUnitService(): NotProductiveUnitService {
    return new NotProductiveUnitImpl()
}